<template>
    <div class="relative inline">
        <Tooltip width="w-40" :align="align">
            <template #tipTrigger>
                <FontAwesomeIcon :icon="faIcon" :class="classIcon" />
            </template>
            <template #tipText>
                <span v-html="tooltipText" />
            </template>
        </Tooltip>
    </div>
</template>

<script setup>
    const props = defineProps({
        faIcon: {
            required: true,
            type: [ String , Array ]
        },
        classIcon: {
            required: true,
            type: String,
        },
        tooltipText: {
            required: true,
            type: String,
        },
        megamenu:{
            type: Boolean,
            default: false,
        }
    })

    const align = computed(() => props.megamenu ? 'right-0' : 'left-0')
</script>
